<form (ngSubmit)="lagre()" [formGroup]="skjema">
  <inline-skjema>
    <inline-skjema-tittel>{{ 'Rediger bruker' | translate }}</inline-skjema-tittel>

    <div class="kontainer">
      <bilde-velger-med-skalering [skjemakontroll]="skjema.controls.avatar"
                                  [knappetekst]="bruker().avatarId ? ('Endre'|translate) : ('Velg'|translate)"
                                  bildedimensjon="120">
        <avatar [bruker]="bruker()"  stil="xxstor"/>
      </bilde-velger-med-skalering>

      <fieldset>
        <mat-form-field class="rolle">
          <mat-label>{{ 'Navn'|translate }}</mat-label>
          <input matInput [formControl]="skjema.controls.navn" data-testid="navn-felt">
          @if (skjema.controls.navn.hasError('maxlength')) {
            <mat-error data-testid="maxlength">{{ skjema.controls.navn.errors | standardvalideringsfeil:'maxlength' }}
            </mat-error>
          }
        </mat-form-field>
      </fieldset>
    </div>

    <inline-skjema-handlinger navigasjonforhindret-flash>
      <button mat-stroked-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial [visSpinner]="lagrer()"
              [disabled]="lagrer() || skjema.invalid" spinnerTekst="{{'Lagrer...'|translate}}">
        {{ "Lagre"|translate }}
      </button>
    </inline-skjema-handlinger>
  </inline-skjema>
</form>
